module.exports = __webpack_public_path__ + "fonts/Gilroy-MediumItalic.27cc5330.eot";